module.exports = __webpack_public_path__ + "static/img/dd-customer-02.4b9f538.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-customer-02.jpg
// module id = uhma
// module chunks = 1